import { TranslateFn } from '../../../hooks/context/useTranslate';
import { checkDateTimeFilterOnSubmit } from '../../../utils/filters/checkDateTimeFilterOnSubmit';
import {
  isEmptyValue,
  validateNumericInput,
  validateTextInput,
} from '../../../utils/managerUtils';

export const validateFormItem = (item, value, t: TranslateFn) => {
  if (item.mandatory && isEmptyValue(value)) {
    return [t('errors.required')];
  }
  if (!isEmptyValue(value)) {
    if (!item.type || item.type === 'string') {
      return validateTextInput(value, item.control, t);
    }
    if (
      item.type === 'integer' ||
      item.type === 'float' ||
      item.control?.type === 'integer' ||
      item.control?.type === 'number'
    ) {
      return validateNumericInput(value.toString(), item.control, t);
    }
    return checkDateTimeFilterOnSubmit(item.control, value, false, t);
  }
  return null;
};
